"use strict";
/**
 * @file Created on 27.05.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NotificationDocConverter_1 = require("../NotificationDocConverter");
/**
 * @author Tomas Leity
 */


var NChangedProdThresholdDTOConverter =
/*#__PURE__*/
function (_NotificationDocConve) {
  _inherits(NChangedProdThresholdDTOConverter, _NotificationDocConve);

  function NChangedProdThresholdDTOConverter() {
    _classCallCheck(this, NChangedProdThresholdDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(NChangedProdThresholdDTOConverter).apply(this, arguments));
  }

  return NChangedProdThresholdDTOConverter;
}(NotificationDocConverter_1.NotificationDocConverter);

exports.NChangedProdThresholdDTOConverter = NChangedProdThresholdDTOConverter;